import { FC } from "react";
import { Icon } from "../../primitives";
import { cn } from "@/ui/lib";


export const CheckboxCheck: FC = () => (
  <div className={cn(
    "text-foreground-inverse flex h-4 w-4 items-center justify-center border border-solid rounded-sys-xs border-component-checkbox-check-unchecked bg-component-checkbox-check-unchecked shadow-sm",
    "peer-checked:border-component-checkbox-check-checked peer-checked:bg-component-checkbox-check-checked peer-checked:[&_.checkbox-icon]:opacity-100",
    "transition-colors ease-in-out duration-200",
    "peer-focus-visible:ring-1 peer-focus-visible:ring-sys-chartreuse-600",
    "peer-disabled:opacity-50",
  )}>
    <Icon
      icon="tick"
      className="checkbox-icon block opacity-0 transition-opacity ease-in-out duration-200"
    />
  </div>
);
